import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AtribucionRegisterUserDto } from '../model/users-model';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss'],
})
export class EditComponent implements OnInit {
  public editUserForm: FormGroup;
  userAtributionsList: string[] = [
    'login',
    'Simulación',
    'Nueva Solicitud',
    'Listar Últimas',
    'Listar Todas',
    'Gestión Intervinientes',
    'Visualizar Traza',
    'Consultar Documentos',
    'Usuario de Impresión',
    'Impresión de Contratos',
    'Hoja de Pago',
    'Ver Operación',
    'Activación de Usuarios',
    'Seguimiento Mes',
    'Seg. Mes Det. Operación',
    'Seg. Mes Det. Vendedor',
    'Inversión por Producto',
    'Inversión por Vendedor',
    'Detalle Operaciones',
    'Informe de Pagos',
    'Inv.x Agente con Det.Ops',
    'Inv. por Producto',
    'Sol. con Det.Ops',
    'Estadistica por Agente',
    'Plan de acción por Agente',
    'Validación Ops',
    'Gral. de Inversión',
    'EXPORTACION EXCEL (Hojas Tarifas)',
    'Impresos de Solicitud',
    'Consulta de Comentarios',
    'Impresión de operaFormciones a firmar en Notaria',
  ]; //seguramente haya que cambiarlo
  availableAtributionsList: AtribucionRegisterUserDto[] = [
    { atributionNumber: '000', atributionName: 'login', activada: 'X', index: 0 },
    { atributionNumber: '009', atributionName: 'Usuario de Impresión', activada: 'X', index: 1 },
    { atributionNumber: '316', atributionName: 'Cambiar Password Propia', activada: 'P', index: 2 },
    { atributionNumber: '708', atributionName: 'Reenviar correo consentimiento y firma', activada: 'X', index: 3 },
    { atributionNumber: '709', atributionName: 'Mantenimiento Lista blanca', activada: 'X', index: 4 },
    { atributionNumber: '710', atributionName: 'Mantenimiento Dispositivos Móviles', activada: 'P', index: 5 },
  ];
  profileList: string[] = [];
  brandList: string[] = [];
  bankTypeList: string[] = [];

  constructor(private router: Router, private formBuilder: FormBuilder) {
    //TODO: ESTO HABRA QUE DESCOMENTARLO CUANDO TODO FUNCIONE PARA QUE COJA EL USUARIO Y CARGUE LA PANTALLA CON EL
    // if (this.router.getCurrentNavigation().extras!==null) {
    //   console.log(this.router.getCurrentNavigation().extras.state.code);
    // }
  }

  ngOnInit(): void {
    this.editUserForm = this.formBuilder.group({
      user: ['', Validators.required],
      supplantedUser: [''],
      profile: ['', Validators.required],
      brand: [''],
      bankType: ['', Validators.required],
      password: [''],
      availableAtributions: this.formBuilder.group({}),
    });

    //TODO: LLAMADA PARA CONSEGUIR LAS ATRIBUCIONES DEL USUARIO

    const formArray = <FormGroup>this.editUserForm.get('availableAtributions');

    this.availableAtributionsList.forEach((x) => {
      if (x.activada === 'X') {
        formArray.addControl(x.index.toString(), new FormControl({ value: true, disabled: true }));
      } else {
        formArray.addControl(x.index.toString(), new FormControl(false));
      }
    });
  }

  editUser() {
    const result = Object.assign({}, this.editUserForm.value, {
      atributions: this.availableAtributionsList.filter((x, i) => {
        if (x.activada === 'X') {
          return true;
        } else {
          return !!this.editUserForm.value.atributions[i];
        }
      }),
    });
    console.log(result);
  }

  searchSupplanted() {}

  comboProfileSelection() {}

  removeUser() {}

  atributionsRows() {
    if (this.userAtributionsList) {
      return this.userAtributionsList.length + 2; //va a haber 3 atribuciones x linea
    } else {
      return 0;
    }
  }

  availableAtributionsRows() {
    if (this.availableAtributionsList) {
      return this.availableAtributionsList.length * 1.25 + 2; //va a haber 3 atribuciones x linea
    } else {
      return 0;
    }
  }
}
